import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rMadenSahalariBilgi, rValue } from '../../models/.catalog';

export default class MadenSahalariBilgiApi extends ApiBase<pList, rValue<rMadenSahalariBilgi>> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/MadenSahalariBilgi',
      }),
      options
    );
  }
}
